export const messages = {
  en: {
    videoControl: {
      title: 'Video Control'
    },
    cameraControlVideo: {
      camera: 'Camera',
      fourWay: 'Four Way',
      sixWay: 'Six Way',
      getVideoUrlError: 'Failed to get video URL'
    },
    selectVideoMachine: {
      title: 'Select Video Machine',
      monitorArea: 'Monitor Area',
      camera: 'Camera',
      loadAreasError: 'Failed to load monitor areas',
      loadMachinesError: 'Failed to load monitor machines'
    }
  },
  zh: {
    videoControl: {
      title: '视频控制'
    },
    cameraControlVideo: {
      camera: '摄像头',
      fourWay: '四路',
      sixWay: '六路',
      getVideoUrlError: '获取视频地址失败'
    },
    selectVideoMachine: {
      title: '选择视频设备',
      monitorArea: '监控区域',
      camera: '摄像头',
      loadAreasError: '加载监控区域失败',
      loadMachinesError: '加载监控设备失败'
    }
  }
}